import { LegalClientBodyType } from 'api/types/entity';

export enum BodyOptionType {
  edit = 'edit',
  delete = 'delete',
  archive = 'archive',
  dearchive = 'dearchive',
}
export interface BodyItem {
  id: string;
  name: string;
  type: LegalClientBodyType;
  otherType?: string;
  archived: boolean;
}
